import type { AppState } from './types';
/** A member export is not a database dump, even when all records are fictional. */
export function exportDemoAccount(state: AppState) {
  const id = state.current_user_id;
  return {
    version: 1,
    generated_at: new Date().toISOString(),
    notice: 'Fictional local demo account export. No live account or provider data.',
    profile: state.members.find((m) => m.id === id),
    private_names: state.private_names?.[id],
    preferences: state.notification_preferences,
    inventory: state.owned_items.filter((i) => i.owner_id === id),
    reviews: state.reviews.filter((r) => r.author_id === id),
    posts: state.posts.filter((p) => p.author_id === id).map(({ comments, ...p }) => p),
    comments: state.posts.flatMap((p) =>
      p.comments.filter((c) => c.author_id === id).map((c) => ({ ...c, post_id: p.id })),
    ),
    stories: state.stories.filter((s) => s.author_id === id),
    forum_topics: state.topics.filter((t) => t.author_id === id).map(({ replies, ...t }) => t),
    forum_replies: state.topics.flatMap((t) =>
      t.replies.filter((r) => r.author_id === id).map((r) => ({ ...r, topic_id: t.id })),
    ),
    trade_listings: state.listings.filter((l) => l.author_id === id),
    messages: state.conversations.flatMap((c) =>
      c.messages.filter((m) => m.author_id === id).map((m) => ({ ...m, conversation_id: c.id })),
    ),
    follows: state.follows.filter((f) => f.follower_id === id || f.following_id === id),
    blocked_accounts: state.blocks,
    muted_accounts: state.mutes,
    reports: state.reports.filter((r) => r.reporter_id === id),
    media_manifest: [],
    media_delivery: 'unconfigured',
  };
}
